import HomeHeading from './HomeHeading'

export default HomeHeading
